<template>
    <div @click="toggleDev" class="Dev-switch">
        <iconBug :class="[{'Dev-switch-on':this.$store.state.showDebug}]" />
    </div>
</template>

<script>
    import iconBug from '@/icons/bug.svg';

    export default {
        name: 'debugArticleSwitch',
        components: {
            iconBug
        },
        methods: {
            toggleDev: function () {
                this.$store.commit('SWITCH_SHOW_DEBUG');
            }
        }
    };
</script>

<style lang="scss">
    @import "../scss/DebugVariables";

    .Dev-switch {
        display: none;
        padding: 5px 0;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 30;
        color: $c1;
        fill: $c1;
        cursor: pointer;
        width: auto;
        transform: scale(.5);
        @media all and (min-width: $xs) { //480
            color: $c2;
            fill: $c2;
        }
        @media all and (min-width: $s) { //736
            color: $c3;
            fill: $c3;
        }
        @media all and (min-width: $m) { //980
            color: $c4;
            fill: $c4;
        }
        @media all and (min-width: $l) { //1280
            color: $c5;
            fill: $c5;
        }
        @media all and (min-width: $xl) { //1690
            color: $c6;
            fill: $c6;
        }
    }

</style>
